import React from 'react';
import NoticesPage from '../Pages/NoticesPage';

const NoticesRoutes = () => {
  return (
    <NoticesPage />
  );
}
export default NoticesRoutes;
